'use strict';
const hide = require('../dom/hide'),
	show = require('../dom/show'),
	px = require('../dom/px'),
	css = require('../dom/css');
module.exports = function updateReorderBounds(element, border, box, dropCoords) {
	if (!border) {
		hide(element);
		return;
	}
	show(element);
	element.setAttribute('mapjs-edge', border.edge);
	if (border.edge === 'top') {
		css(element, {
			top: px(border.minY),
			left: px(Math.round(dropCoords.x - element.clientWidth / 2))
		});
	} else if (border.edge === 'bottom') {
		css(element, {
			top: px(border.maxY),
			left: px(Math.round(dropCoords.x - element.clientWidth / 2))
		});
	} else {
		css(element, {
			top: px(Math.round(dropCoords.y - element.clientHeight / 2)),
			left: px(border.x - (border.edge === 'left' ? element.clientWidth : 0))
		});
	}

};
